export default "__VITE_ASSET__DMUWkMBh__"